<template>
  <SogDialog
    id="main"
    ref="_paymentDialog"
    target="#app"
    :dialog-buttons="SogDialogButtons.OkCancel"
    @click-ok="onOk"
    @click-cancel="onHide"
  >
    <SogCard>
      <SogCardTitle>Bezahlung</SogCardTitle>
      <SogCardContent>
        <table>
          <tr>
            <td>Bezahlt am</td>
            <td>
              <SogDatePicker
                v-model="_date"
                value-type="Date"
                width="270px"
              />
            </td>
          </tr>
          <tr>
            <td>Bezahlart</td>
            <td>
              <SogDropDownList
                v-model="_selectedItem"
                :data-source="_items"
                width="100%"
              />
            </td>
          </tr>
          <tr v-show="_selectedItem === 'Bank'">
            <td>Bank</td>
            <td>
              <SogTextBox
                v-model="_bankInput"
                width="100%"
              />
            </td>
          </tr>
          <tr>
            <td>Hinweise</td>
            <td>
              <SogTextBox
                v-model="_noteInput"
                :multiline="true"
                width="100%"
              />
            </td>
          </tr>
        </table>
      </SogCardContent>
    </SogCard>
  </SogDialog>
</template>

<script setup lang="ts">

import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";
import {reactive, ref} from "vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogDialog from "@/shared/ui/SogDialog.vue";
import {SogDialogButtons} from "@/shared/ui/types/SogDialogButtons";
import OrderHead from "@/shared/model/orderHead";
import SogDatePicker from "@/shared/ui/SogDatePicker.vue";
import Payment from "@/shared/model/Payment";
import {useSpinner} from "@/shared/composables/SogSpinner";
import apiOrder from "@/modules/Order/api";
import notificationService from "@/shared/services/NotificationService";

const _items = reactive([{id: "Bank", value: "Überweisung"}, {id: "Cashbook", value: "Kassenbuch"}]);
const _selectedItem = ref("Bank");
const _bankInput = ref("")
const _noteInput = ref("")
const _date = ref(new Date())
const _paymentDialog = ref<InstanceType<typeof SogDialog> | null>(null)
const _spinner = useSpinner("main")


interface Props {
  orderHead?: OrderHead
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    orderHead: undefined
  }
)
const emit = defineEmits<{
  (e: 'okClicked'): void,
}>()

async function onOk() {
  const payment = new Payment();
  payment.date = _date.value;
  payment.paymentTypeId = _selectedItem.value;
  payment.bank = _bankInput.value;
  payment.memo = _noteInput.value;
  payment.orderId = props.orderHead?.id ?? "";
  _spinner.show()
  const res = await apiOrder.payRequest(payment)
  if (res) {
    notificationService.success("Bezahlung erfolgreich")
    onHide();
    emit("okClicked")
  }
  _spinner.hide();
}

function onHide() {
  _paymentDialog.value?.hide()
}


function showModal() {
  _paymentDialog.value?.show()
}

defineExpose({
  showModal
})

</script>

<style scoped>
td {
  padding-bottom: 5px;
}

td {
  padding-right: 5px;
}

</style>
